import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import {
  MixCheckbox,
  MixMainCheckbox,
} from './MixCheckbox';
import {
  Col,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import Filters from '../../components/Filters/Filters';
import PaginationTable from '../../components/Pagination/PaginationTable';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import { withTranslation } from 'react-i18next';

class MixTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [{id: 'itemCode', desc: false}],
      filter: '',
    };
  }

  onEdit = id => {
    const { mixStore, onEdit } = this.props;
    mixStore.selectMix(id);
    onEdit();
  };

  onPreview = id => {
    const { mixStore, onPreview } = this.props;
    mixStore.selectMix(id);
    onPreview();
  };

  onDelete = id => {
    const { mixStore, onDelete } = this.props;
    mixStore.deleteMix(id);
    onDelete();
  };

  onClone = id => {
    const { onClone } = this.props;
    onClone(id);
  };

  renderCheckbox = row => {
    const id = row.value.itemId;
    if (!row.value.offline) {
      return id;
    }

    return <MixCheckbox id={id} />;
  };

  renderMainCheckbox = row => {
    return <MixMainCheckbox />;
  };

  getColumns = (offline) => {
    const { t } = this.props;
    const { sorted } = this.state;

    const columns = [
      {
        headerText: t('Code'),
        accessor: 'itemCode',
        id: 'itemCode',
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
        maxWidth: 120,
      },
      {
        headerText: t('Description'),
        accessor: 'itemDescription',
        id: 'itemDescription',
        ...getSortHeaderProps(sorted),
      },
      {
        headerText: t('Unit'),
        accessor: 'unitSymbol',
        id: 'unitSymbol',
        ...getSortHeaderProps(sorted),
        maxWidth: 70,
      },
      {
        headerText: t('Slump'),
        accessor: 'slump',
        id: 'slump',
        ...getSortHeaderProps(sorted),
        maxWidth: 70,
      },
      {
        headerText: t('Taxable'),
        accessor: d => d.taxable ? t('Yes') : t('No'),
        id: 'taxable',
        ...getSortHeaderProps(sorted),
        maxWidth: 70,
      },
      {
        accessor: 'actions',
        maxWidth: 100,
        Cell: row => (
          <div className="text-right">
            {!offline
              ? (
                <a className="btn btn-sm btn-default btn-action"
                  title={t('Preview')}
                  onClick={() => this.onPreview(row.original.itemId)}>
                  <i className="fa fa-pencil"/>
                </a>
              )
              : (
                <a className="btn btn-sm btn-default btn-action"
                  title={t('Edit')}
                  onClick={() => this.onEdit(row.original.itemId)}>
                  <i className="fa fa-pencil"/>
                </a>
              )}
            {offline && (
              <a className="btn btn-sm btn-default btn-action"
                title={t('Save')}
                onClick={() => this.onClone(row.original.id)}>
                <i className="fa fa-copy"/>
              </a>
            )}
            {offline && (
              <a className="btn btn-sm btn-default btn-action"
                title={t('Delete')}
                onClick={() => this.onDelete(row.original.id)}>
                <i className="fa fa-remove"/>
              </a>
            )}
          </div>
        ),
      },
    ];

    // if (offline) {
    //   columns.unshift({
    //     Header: this.renderMainCheckbox,
    //     accessor: d => d,
    //     id: 'checkbox',
    //     Cell: this.renderCheckbox,
    //     maxWidth: 30
    //   });
    // }

    return columns;
  };

  handleChange = (e) => {
    const filter = e.target.value;
    this.setState({ filter });
  };

  render() {
    const { mixStore, connectionStore, t } = this.props;
    const { mixes, allMixes } = mixStore;
    const { filter } = this.state;

    return (
      <div>
        {!!mixes.length && !connectionStore.isOnline && (
          <div>
            <h4>{t('Mixes')} - {t('Locally')}</h4>
            <ReactTable
              className="-highlight mix-table"
              data={mixes}
              columns={this.getColumns(true)}
              sorted={this.state.sorted}
              onSortedChange={sorted => this.setState({ sorted })}
              showPaginationTop={false}
              showPaginationBottom={true}
              showPageSizeOptions={false}
              PaginationComponent={PaginationTable}
              resizable={false}
              minRows={0}
              defaultPageSize={100}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: () => {
                      this.onPreview(rowInfo.original.itemId);
                      this.setState({
                        selected: rowInfo.index,
                      });
                    },
                    className: rowInfo.index === this.state.selected ? 'row-selected': '',
                  };
                }
                return {};
              }}
            />
          </div>
        )}
        <div>
          <Col sm={4} xs={10} className={'no-padding'}>
            <FormGroup>
              <FormControl
                type="text"
                value={filter}
                placeholder={t('Search')}
                onChange={this.handleChange}
              />
            </FormGroup>
          </Col>
          <Filters filter={filter} data={allMixes} renderData={(items) => (
            <ReactTable
              className="-highlight mix-table"
              data={items}
              noDataText={' '}
              columns={this.getColumns()}
              sorted={this.state.sorted}
              onSortedChange={sorted => this.setState({ sorted })}
              showPaginationTop={false}
              showPaginationBottom={true}
              showPageSizeOptions={true}
              PaginationComponent={PaginationTable}
              resizable={false}
              minRows={1}
              defaultPageSize={100}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: () => {
                      this.onPreview(rowInfo.original.itemId);
                      this.setState({
                        selected: rowInfo.index,
                      });
                    },
                    className: rowInfo.index === this.state.selected ? 'row-selected': '',
                  };
                }
                return {};
              }}
            />
          )} />
        </div>
      </div>
    );
  }
}

export default withTranslation()(inject('mixStore', 'connectionStore')(observer(MixTable)));
